// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import reportWebVitals from './reportWebVitals';
import { startOfflineRetryWorker } from './offlinerHelper.tsx';

// 1. **CRITICAL FIX:** Import the Service Worker registration module.
//    (The extension might be .js or .ts depending on your project template)
// import * as serviceWorkerRegistration from './service-worker1.js'; 
// startOfflineRetryWorker();
// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker
//       .register("/service-worker.js")
//       .then(reg => console.log("✅ Service Worker registered:", reg.scope))
//       .catch(err => console.error("❌ Service Worker registration failed:", err));
//   });
// }
const root = ReactDOM.createRoot(document.getElementById('root'));

// 2. Call the imported function to register the Service Worker for PWA features.
// navigator.serviceWorker.register('/service-worker1.js')


root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();